import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import DashboardPage from "./pages/DashboardPage";
import ReportsListPage from "./pages/ReportsListPage";
import LoginPage from "./pages/LoginPage";
import XandrSetupPage from "./pages/XandrSetupPage";
import authService from "./services/authService";
import SharedReportPage from "./pages/SharedReportPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import EditUserPage from "./pages/EditUserPage";
import RegisterPage from "./pages/RegisterPage";
import CampaignDashboard from "./pages/CampaignDashboard";
import CreateSmsEmailReportPage from "./pages/CreateSmsEmailReportPage";

const HealthCheck = () => {
  return <div>ok</div>;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUserData = async () => {
    try {
      const currentUser = await authService.getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.error("Erreur lors de la récupération de l'utilisateur:", error);
    }
  };

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà connecté
    const checkAuth = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error(
          "Erreur lors de la vérification de l'authentification:",
          error
        );
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    authService.logout();
    setUser(null);
  };

  const handleXandrCredentialsSaved = async () => {
    await refreshUserData();
  };

  if (loading) {
    return <div>Chargement de l'application...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/healthz" element={<HealthCheck />} />
        <Route
          path="/login"
          element={
            user ? <Navigate to="/" /> : <LoginPage onLogin={handleLogin} />
          }
        />
        <Route
          path="/setup-xandr"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <XandrSetupPage onSaved={handleXandrCredentialsSaved} />
            )
          }
        />
        <Route
          path="/"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <HomePage user={user} onLogout={handleLogout} />
            )
          }
        />
        <Route
          path="/dashboard/:reportId"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <DashboardPage user={user} onLogout={handleLogout} />
            )
          }
        />
        <Route
          path="/reports"
          element={
            !user ? (
              <Navigate to="/login" />
            ) : (
              <ReportsListPage user={user} onLogout={handleLogout} />
            )
          }
        />
        <Route path="/shared/:token" element={<SharedReportPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/campaign/:dataId" element={<CampaignDashboard />} />
        <Route
          path="/admin/users"
          element={<AdminUsersPage user={user} onLogout={handleLogout} />}
        />
        <Route
          path="/edit-user/:userId"
          element={<EditUserPage user={user} onLogout={handleLogout} />}
        />
        <Route
          path="/create-sms-email-report"
          element={<CreateSmsEmailReportPage />}
        />
      </Routes>
    </Router>
  );
}

export default App;
